mutation SendWebMessage(
  $input: WebMessageInput!
) {
  sendWebMessage(
    input: $input
  )
}
